import { ScrollTrigger } from "@gsap";

const parser = new DOMParser();
const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const headerOffset = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--pk-header-height")) || 0;

function scrollToGrid(grid) {
	const offset = headerOffset();
	if (grid.getBoundingClientRect().top >= offset) return;
	const top = grid.getBoundingClientRect().top + window.scrollY - offset;
	window.scrollTo({ top, behavior: prefersReducedMotion() ? "auto" : "smooth" });
}

function syncForms(key, doc) {
	document.querySelectorAll(`form[data-ajax-filter="${key}"]`).forEach((form) => {
		const fresh = doc.querySelector(`form[data-ajax-filter="${key}"]`);
		if (!fresh) return;
		form.querySelectorAll("[name]").forEach((field) => {
			const match = fresh.querySelector(`[name="${field.name}"]`);
			if (match) field.value = match.value;
		});
	});
}

function gridFor(element, attribute) {
	return element.closest("[data-ajax-grid]") || document.querySelector(`[data-ajax-grid="${element.getAttribute(attribute)}"]`);
}

async function load(grid, url, push = true) {
	const key = grid.dataset.ajaxGrid;
	grid.setAttribute("aria-busy", "true");
	grid.classList.add("is-loading");

	try {
		const response = await fetch(url, { headers: { "X-Requested-With": "fetch" } });
		if (!response.ok) throw new Error(response.status);

		const doc = parser.parseFromString(await response.text(), "text/html");
		const fresh = doc.querySelector(`[data-ajax-grid="${key}"]`);
		if (!fresh) throw new Error("missing grid");

		grid.innerHTML = fresh.innerHTML;
		grid.className = `${fresh.className} is-loading`;
		document.querySelectorAll("[data-ajax-sync]").forEach((el) => {
			const match = doc.querySelector(`[data-ajax-sync="${el.dataset.ajaxSync}"]`);
			if (match) el.innerHTML = match.innerHTML;
		});
		syncForms(key, doc);
		document.title = doc.title;
		if (push) history.pushState({ ajaxGrid: key }, "", url);

		scrollToGrid(grid);
		grid.focus({ preventScroll: true });
		window.pkReveal?.(grid);
		ScrollTrigger.refresh();
	} catch (error) {
		window.location.href = url;
	} finally {
		grid.removeAttribute("aria-busy");
		grid.classList.remove("is-loading");
	}
}

function filterUrl(form) {
	const url = new URL(form.action || window.location.href, window.location.origin);
	url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, "/");
	url.search = new URLSearchParams([...new FormData(form)].filter(([, value]) => value !== "")).toString();
	return url.toString();
}

function initAjaxGrids() {
	const grids = document.querySelectorAll("[data-ajax-grid]");
	if (!grids.length) return;

	history.scrollRestoration = "manual";
	history.replaceState({ ajaxGrid: true }, "");

	grids.forEach((grid) => grid.setAttribute("tabindex", "-1"));

	document.addEventListener("click", (event) => {
		const link = event.target.closest("[data-ajax-grid] .pk-pagination a, a[data-ajax-reset]");
		if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
		const grid = gridFor(link, "data-ajax-reset");
		if (!grid) return;
		event.preventDefault();
		load(grid, link.href);
	});

	document.addEventListener("submit", (event) => {
		const form = event.target.closest("form[data-ajax-filter]");
		const grid = form && gridFor(form, "data-ajax-filter");
		if (!grid) return;
		event.preventDefault();
		load(grid, filterUrl(form));
	});

	document.addEventListener("change", (event) => {
		const form = event.target.closest("form[data-ajax-filter]");
		if (!form || form.hasAttribute("data-ajax-filter-submit")) return;
		const grid = gridFor(form, "data-ajax-filter");
		if (grid) load(grid, filterUrl(form));
	});

	window.addEventListener("popstate", (event) => {
		if (!event.state?.ajaxGrid) return;
		grids.forEach((grid) => load(grid, window.location.href, false));
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initAjaxGrids);
} else {
	initAjaxGrids();
}
